import { atom } from "recoil";
import { IMirageApplications } from "@shared/mirage/core/IMirageApplications";

export const currentApplication = atom({
    key: "currentApplication",
    default: "" as IMirageApplications,
});
